import { render, staticRenderFns } from "./video.vue?vue&type=template&id=66fbb1de&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&id=66fbb1de&prod&lang=css&"
import style1 from "./video.vue?vue&type=style&index=1&id=66fbb1de&prod&lang=less&scoped=true&"
import style2 from "./video.vue?vue&type=style&index=2&id=66fbb1de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fbb1de",
  null
  
)

export default component.exports